import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehicleGroupColorsComponent } from './vehicle-group-colors.component';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
  declarations: [VehicleGroupColorsComponent],
  exports: [VehicleGroupColorsComponent],
  imports: [CommonModule, OverlayModule],
})
export class VehicleGroupColorsModule {}
